export default __webpack_public_path__ + "static/media/Deed of Contract - Img - Final (2)_02.fa020f4f.jpg";